<template>
  <div class="dashboard">
    <b-container fluid>
      <div class="bienvenida">
        <span class="name">Hola {{ currentUser.name }},</span><span class="hello"> ¿Qué necesitas hacer ahora?</span>
      </div>
      <div class="mb-2">
        <b-row
          class="list-dashboard mt-2"
          align-v="stretch"
        >
          <b-col
            sm="3"
            lg
            class="list-item ml-1 mr-1 mb-1"
          >
            <b-link :to="{ name: 'departments' }">
              <div class="text-dark">
                <feather-icon
                  icon="ClipboardIcon"
                  size="22"
                />
              </div>
              <div class="pt-05 pb-1">
                <span>Ver listado <br>
                  de <strong>departamentos</strong></span><br>
              </div>
              <div class="icon-flecha">
                <icon-flecha />
              </div>
            </b-link>
          </b-col>
          <b-col
            sm="3"
            lg
            class="list-item mr-1 ml-1 mb-1"
          >
            <b-link :to="{ name: 'users' }">
              <div class="text-dark">
                <feather-icon
                  icon="UsersIcon"
                  size="22"
                />
              </div>
              <div class="pt-05 pb-1">
                <span>Ver listado <br>de
                  <span class="text-bold">usuarios</span></span>
              </div>
              <div class="icon-flecha">
                <icon-flecha />
              </div>
            </b-link>
          </b-col>
          <b-col
            sm="3"
            lg
            class="list-item mr-1 ml-1 mb-1"
          >
            <b-link :to="{ name: 'partesOperario' }">
              <div class="text-dark">
                <icon-tasks-pending />
              </div>
              <div class="pt-05 pb-1">
                <span>Ver parte de<br>
                  horas de los <span class="text-bold">operarios</span></span>
              </div>
              <div class="icon-flecha">
                <icon-flecha />
              </div>
            </b-link>
          </b-col>
        </b-row>
      </div>
      <List />
    </b-container>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BLink,
  BModal,
  BFormGroup,
  BForm,
  BButton,
} from 'bootstrap-vue'
import iconTasks from '@/assets/images/icons/talleres-mata/tareas_new'
import homeCircle from '@/assets/images/icons/talleres-mata/casita_con_circulo'
import iconTasksPending from '@/assets/images/icons/talleres-mata/tareas_pending'
import iconFlecha from '@/assets/images/icons/talleres-mata/icon-flecha-abajo'
import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import router from '@/router'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    iconTasks,
    homeCircle,
    iconTasksPending,
    iconFlecha,
    BLink,
    BModal,
    BFormGroup,
    vSelect,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/getUser',
    }),
  },
  data() {
    return {
      project: '',
      client: '',
      log: [],
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.createJob.validate().then(success => {
        if (success) {
          router.push({
            name: 'createJob',
            params: { project_param: this.project.id },
          })
        }
      })
    },
    async openCreateTask(job) {
      console.log(job)
      this.job = job
      this.showCreateTask = true
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
